/**
 * ResolutionDetectorMenuCalendar Hook
 * 
 * Versão específica do ResolutionDetector que envia corretamente
 * para o LiveComponent MenuCalendar usando pushEventTo
 */

export const ResolutionDetectorMenuCalendarHook = {
  mounted() {
    console.warn('🎯 [ResDetectorMenuCal] HOOK MOUNTED! Element ID:', this.el.id);
    
    // Small delay to ensure component is fully mounted
    setTimeout(() => {
      console.warn('🎯 [ResDetectorMenuCal] Calling detectAndNotify after mount delay');
      this.detectAndNotify();
    }, 100);
    
    // Listen for resize events with debouncing
    this.resizeHandler = this.debounce(() => {
      this.detectAndNotify();
    }, 300);
    
    window.addEventListener('resize', this.resizeHandler);
    console.log('🎯 [ResDetectorMenuCal] Resize listener attached');
  },
  
  destroyed() {
    if (this.resizeHandler) {
      window.removeEventListener('resize', this.resizeHandler);
    }
  },
  
  getConfigOverride() {
    const override = document.body.dataset.layoutOverride;
    if (override && override !== 'auto' && override !== 'horizontal_16_9') return override;
    return null;
  },

  detectAndNotify() {
    const width = window.innerWidth;
    const height = window.innerHeight;
    const isPortrait = height > width;
    const configOverride = this.getConfigOverride();
    const layout = configOverride || this.getLayout(width, height);
    const aspectRatio = (width / height).toFixed(2);

    console.warn(`🎯 [ResDetectorMenuCal] ${width}×${height}px, Aspect: ${aspectRatio}, Layout: ${layout}${configOverride ? ' (override)' : ''}`);

    // Set body dataset for CSS header styling
    document.body.dataset.kioskLayout = layout;

    // Store current layout in element
    this.el.dataset.currentLayout = layout;
    this.el.dataset.screenWidth = width;
    this.el.dataset.screenHeight = height;

    // Send to LiveComponent using pushEventTo
    try {
      console.warn(`🎯 [ResDetectorMenuCal] Sending to LiveComponent with pushEventTo`);
      this.pushEventTo('#kiosk-menu-calendar', 'resolution_changed', {
        width,
        height,
        layout,
        is_portrait: isPortrait,
        is_small: width <= 1024,
        aspect_ratio: aspectRatio
      });
      console.warn(`🎯 [ResDetectorMenuCal] Event sent successfully via pushEventTo`);
    } catch (error) {
      console.error(`🎯 [ResDetectorMenuCal] Error sending event:`, error);
    }
  },

  getLayout(width, height) {
    // Portrait: height > width (vertical screens 768×1366, 1080×1920)
    if (height > width) return 'portrait';
    // Landscape rules:
    // - <=768px: compact (mobile)
    // - <=1366px: matrix (periods as columns), stable for 1024×768 and 1280×800
    // - >1366px: vertical (days as columns)
    if (width <= 768) return 'compact';
    if (width <= 1366) return 'matrix';
    return 'vertical';
  },
  
  debounce(func, wait) {
    let timeout;
    return function executedFunction(...args) {
      const later = () => {
        clearTimeout(timeout);
        func(...args);
      };
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
    };
  }
};
